import { StoreAction } from "../../@core/constants";

const initialState = {
  colorList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_COLOR_DATA:
      return {
        ...state,
        colorList: action.payload,
      };

    default:
      return state;
  }
}
